import { useState } from 'react';
import { Cancel } from "@mui/icons-material";

interface NewSelfServiceFormProps {
  handleClose: () => void;
  handleSubmit: (formData: VenueFormData) => void;
}

interface VenueFormData {
  venueName: string;
  venueAddress: string;
  venueCapacity: string;
  venueDescription: string;
}

const NewSelfServiceForm: React.FC<NewSelfServiceFormProps> = ({ handleClose, handleSubmit }) => {
  const [formData, setFormData] = useState<VenueFormData>({
    venueName: '',
    venueAddress: '',
    venueCapacity: '',
    venueDescription: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit(formData);
    // Reset form
    setFormData({
      venueName: '',
      venueAddress: '',
      venueCapacity: '',
      venueDescription: ''
    });
  };

  return (
    <div className="w-full max-w-2xl mx-auto p-4">
      <span onClick={handleClose} className="ml-auto w-full flex cursor-pointer">
        <Cancel className="text-[#A1A1A1] hover:text-[#777] h-[18px] w-[18px] ml-auto" />
      </span>
      <h2 className="text-center text-xl font-semibold text-primary-200 font-raleway">
        Add Self Service Option
      </h2>
      <p className="mb-2 text-center text-sm text-back-200 font-open-sans">
        Enter self service details below
      </p>
      <form className="space-y-4" onSubmit={onSubmit}>
        <div>
          <label htmlFor="venueName" className="block text-sm font-medium text-primary-200">
            Self Service Name
          </label>
          <input
            type="text"
            id="venueName"
            value={formData.venueName}
            onChange={handleChange}
            className="mt-1 block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            placeholder="Enter name"
            required
          />
        </div>

        <div>
          <label htmlFor="venueAddress" className="block text-sm font-medium text-primary-200">
            Address
          </label>
          <input
            type="text"
            id="venueAddress"
            value={formData.venueAddress}
            onChange={handleChange}
            className="mt-1 block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            placeholder="Enter address"
            required
          />
        </div>

        <div>
          <label htmlFor="venueCapacity" className="block text-sm font-medium text-primary-200">
            Capacity
          </label>
          <input
            type="number"
            id="venueCapacity"
            value={formData.venueCapacity}
            onChange={handleChange}
            className="mt-1 block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            placeholder="Enter capacity"
            required
          />
        </div>

        <div>
          <label htmlFor="venueDescription" className="block text-sm font-medium text-primary-200">
            Description
          </label>
          <textarea
            id="venueDescription"
            value={formData.venueDescription}
            onChange={handleChange}
            rows={3}
            className="mt-1 block w-full border-[1px] border-[#E9E9E9] rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
            placeholder="Enter description"
          />
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className="w-full font-open-sans flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-semibold text-white bg-primary-200 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300 transition-colors"
          >
            Add Self Service
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewSelfServiceForm;